import { useMemo } from 'react';

import { useAuth } from '@features/auth/hooks/useAuth';
import { useMyTicketsQuery } from '@features/shared/api/user';

import { CHESS_RUSSIAN_CLUB_ID, SCHOOL_TICKET } from '../constants';
import { findUserTicket } from '../utils/user-tickets';

export function useIsChessRussianStudent() {
  const { isAuthenticated } = useAuth();
  const { data, isLoading } = useMyTicketsQuery({
    enabled: isAuthenticated,
  });

  const isStudent = useMemo(
    () => Boolean(findUserTicket(data, CHESS_RUSSIAN_CLUB_ID, SCHOOL_TICKET)),
    [data],
  );

  return { isLoading, isStudent };
}
